import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { approve } from '../core/_requests'
import { useIntl } from 'react-intl'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Swal from 'sweetalert2'

export function ApprovePage() {
    const { approvalGuid } = useParams()
    const intl = useIntl()
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)

    const formik = useFormik({
        initialValues: {
            password: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required(intl.formatMessage({ id: 'REQUIRED' }))
                .min(8, intl.formatMessage({ id: 'MIN_8_CHARACTERS' })),
            confirmPassword: Yup.string()
                .required(intl.formatMessage({ id: 'REQUIRED' }))
                .oneOf([Yup.ref('password'), null], intl.formatMessage({ id: 'PASSWORDS_MUST_MATCH' }))
        }),
        onSubmit: async (values) => {
            setLoading(true)
            try {
                await approve(approvalGuid || "", values.password)
                // Şifre başarıyla ayarlandı
                Swal.fire({
                    title: intl.formatMessage({ id: 'Password Set' }),
                    text: intl.formatMessage({ id: 'Your password has been set. You can now login.' }),
                    icon: 'success',
                    confirmButtonText: intl.formatMessage({ id: 'Login' })
                }).then(() => {
                    navigate('/auth/login');
                });
            } catch (error) {
                // Hata işleme
            } finally {
                setLoading(false)
            }
        },
    })

    return (
        <div>
            <h3>{intl.formatMessage({ id: 'Set Your Password' })}</h3>
            <Form onSubmit={formik.handleSubmit}>
                <Form.Group className='mb-3' controlId='password'>
                    <Form.Label>{intl.formatMessage({ id: 'Password' })}</Form.Label>
                    <Form.Control
                        type='password'
                        name='password'
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.password && !!formik.errors.password}
                    />
                    <Form.Control.Feedback type='invalid'>
                        {formik.errors.password}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className='mb-3' controlId='confirmPassword'>
                    <Form.Label>{intl.formatMessage({ id: 'Confirm Password' })}</Form.Label>
                    <Form.Control
                        type='password'
                        name='confirmPassword'
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.confirmPassword && !!formik.errors.confirmPassword}
                    />
                    <Form.Control.Feedback type='invalid'>
                        {formik.errors.confirmPassword}
                    </Form.Control.Feedback>
                </Form.Group>

                <Button variant='primary' type='submit' disabled={loading}>
                    {loading ? intl.formatMessage({ id: 'Loading...' }) : intl.formatMessage({ id: 'Submit' })}
                </Button>
            </Form>
        </div>
    )
}
